import gsap, { Linear, Quad } from 'gsap';
import { BarbaTransition } from './BarbaTransition';

const TRANSITION_DURATION: number = 1.5;
const TRANSITION_EASE_ENTER: any = Quad.easeInOut;
const TRANSITION_EASE_LEAVE: any = Quad.easeInOut;
const FADE_TRANSITION_PANEL_CLASS: string = 'barba__fade';
const COVER_TRANSITION_PANEL_CLASS: string = 'barba__cover';

export class BarbaTransitionVertWipe extends BarbaTransition {
	private addFadeTransitionPanel(): HTMLElement {
		const div = document.createElement('div');
		div.className = FADE_TRANSITION_PANEL_CLASS;
		const header = document.querySelector('header');
		header?.appendChild(div);
		return div;
	}

	private addCoverTransitionPanel(): HTMLElement {
		const div = document.createElement('div');
		div.className = COVER_TRANSITION_PANEL_CLASS;
		const header = document.querySelector('header');
		header?.appendChild(div);
		return div;
	}

	handleLeave(_data: any, onAnimationComplete?: () => void) {
		// Slight fade over all page content
		const fadePanel = this.addFadeTransitionPanel();
		gsap.fromTo(fadePanel, { opacity: 0 }, { duration: TRANSITION_DURATION * 0.25, opacity: 0.5, ease: Linear.easeNone });

		// Wipe an opaque cover over the page
		const coverPanel = this.addCoverTransitionPanel();
		gsap.set(coverPanel, { y: window.innerHeight });

		return gsap.to(coverPanel, {
			duration: TRANSITION_DURATION * 0.5,
			y: 0,
			ease: TRANSITION_EASE_LEAVE,
			onComplete: () => {
				// Remove the fade panel
				fadePanel?.remove();

				onAnimationComplete && onAnimationComplete();
			},
		});
	}

	handleEnter(_data: any, onAnimationComplete?: () => void) {
		// Gradually remove the page cover
		const coverPanel = document.querySelector(`.${COVER_TRANSITION_PANEL_CLASS}`);
		gsap.to(coverPanel, {
			duration: TRANSITION_DURATION * 0.5,
			y: -window.innerHeight * 1.5,
			ease: TRANSITION_EASE_ENTER,
			onComplete: () => {
				// Remove the page cover
				coverPanel?.remove();

				onAnimationComplete && onAnimationComplete();
			},
		});
	}
}
